import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { showErrorToast } from '../../../components/atoms/Utlis/Toast';
import { createQuotationAPI, getAllQuotationAPI } from '../../ApiCalls/Dashboard/QuotationAPI';
import { QuotationState } from '../../Slice/Dashboard/QuotationSlice';

export const QuotationReducer = (builder: ActionReducerMapBuilder<QuotationState>) => {
    builder
        .addCase(createQuotationAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.error = {};
        })
        .addCase(createQuotationAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
        })
        .addCase(createQuotationAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message);
            } else {
                console.log(action.payload);
            }
        })
        .addCase(getAllQuotationAPI.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.error = {};
        })
        .addCase(getAllQuotationAPI.fulfilled, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = false;
            // Handle paginated results or raw array
            state.allQuotations = action.payload?.results || action.payload || [];
            state.totalCount = action.payload?.count || (action.payload?.results ? action.payload.results.length : action.payload?.length) || 0;
        })
        .addCase(getAllQuotationAPI.rejected, (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.isError = true;
            if (action.payload && action.payload.message) {
                showErrorToast(action.payload.message);
            }
        });
};

